interface IActionTemplateStub {
	Name: string;
  Id: number;
  Mode: actionTemplateModes;
}

enum actionTemplateModes {
  Standard,
  Save,
  Merge
}

module ActionTemplateFactory {
	interface templatesByDepartmentRequest {
		DepartmentId: string;
    Modes: actionTemplateModes[];
    OnlyFaxReceivable: boolean;
	}

	export function getActionTemplateByDepartment(departmentId: string, callback: (actionTemplateStubs: IActionTemplateStub[]) => any, modes: actionTemplateModes[], onlyFaxReceivable: boolean = false) {
		const requestData: templatesByDepartmentRequest = {
			DepartmentId: departmentId,
      Modes: modes,
      OnlyFaxReceivable: onlyFaxReceivable
		};
		$.ajax(
			"/Api/Company/Actions/Templates/TemplatesByDepartment",
			{
				data: JSON.stringify(requestData),
				contentType: "application/json; charset=utf-8",
				dataType: "json",
				type: "POST",
				timeout: 5000,
				success: callback,
				error: () => Notifications.Warning("Error occurred attempting to retrieve list of Action Templates by Department.")
			}
		);
	}
}